var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaygroundLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 451,
    height: 452,
    viewBox: "0 0 451 452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M402.127 166.999a203.009 203.009 0 0 0-2.993-12.814C370.546 47.492 260.878-15.825 154.185 12.764 47.492 41.352-15.825 151.02 12.764 257.713c20.266 75.633 81.275 129.469 153.087 144.22"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.287 141.272a5.86 5.86 0 0 1-7.177-4.143l-19.185-68.053a5.86 5.86 0 0 1 11.32-3.033l19.185 68.053a5.86 5.86 0 0 1-4.143 7.176zM274.287 174.416a5.86 5.86 0 0 1-4.742-10.553l58.678-37.909a5.857 5.857 0 0 1 8.117 1.665 5.858 5.858 0 0 1-1.666 8.117l-58.677 37.91a5.846 5.846 0 0 1-1.71.77zM135.912 209.79a5.842 5.842 0 0 1-1.866.188L60.5 206.961a5.86 5.86 0 1 1 .696-11.698l73.546 3.018a5.86 5.86 0 0 1 1.169 11.51zM161.774 350.397a5.831 5.831 0 0 1-3.445-.13c-3.597-1.258-4.665-4.41-3.597-7.465l23.332-62.558a5.859 5.859 0 1 1 11.062 3.867l-23.332 62.558a5.852 5.852 0 0 1-4.02 3.728z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.77 6.306L172.051 64a4.015 4.015 0 0 1-4.558 1.22L97.012 38.16c17.16-11.14 36.337-19.81 57.174-25.394 21.642-5.799 43.4-7.814 64.583-6.459zM165.124 401.78c-28.918-6.052-56.068-18.45-79.476-36.055l70.206-18.812a4.013 4.013 0 0 1 4.405 1.691l7.163 11.032M57.776 199.646a4.013 4.013 0 0 1-.248 4.712l-44.37 54.787a94.115 94.115 0 0 1-.393-1.433c-10.995-41.036-8.392-82.499 5.039-119.624l39.972 61.558z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.78 188.202l.873-16.659a4.014 4.014 0 0 0-2.57-3.957l-77.213-29.64a4.014 4.014 0 0 0-4.558 1.221l-52.05 64.276a4.013 4.013 0 0 0-.246 4.712l45.045 69.363a4.014 4.014 0 0 0 4.405 1.691M399.133 154.186c.128.48.255.953.376 1.436l-65.82-25.261a4.014 4.014 0 0 1-2.57-3.957l3.835-73.305c30.195 25.437 53.183 60.05 64.179 101.087z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M444.377 256.212c-1.4 16.332-3.871 31.815-7.387 46.283-1.996 8.206-4.324 16.09-6.987 23.613-9.3 26.32-22.679 48.327-39.76 65.407-17.08 17.082-39.088 30.46-65.408 39.761-7.522 2.663-15.407 4.991-23.613 6.987-14.468 3.516-29.951 5.987-46.283 7.387a379.219 379.219 0 0 1-32.143 1.35c-27.015 0-45.66-2.793-46.703-2.953l-5.955-.912-.912-5.955c-.22-1.427-5.315-35.478-1.603-78.846 1.4-16.332 3.871-31.815 7.387-46.283 1.996-8.206 4.324-16.09 6.987-23.613 9.3-26.32 22.679-48.327 39.76-65.407 17.08-17.082 39.088-30.461 65.408-39.761 7.522-2.663 15.407-4.991 23.613-6.987 14.468-3.516 29.951-5.987 46.283-7.388 43.372-3.712 77.42 1.384 78.846 1.604l5.955.912.912 5.955c.22 1.426 5.315 35.478 1.603 78.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.735 312.648l126.707 125.557M311 174l126.707 125.557"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.07 310.634l7.194-6.947 48.626 50.354-7.193 6.947zM266.493 291.878l7.193-6.947 48.626 50.354-7.193 6.947zM285.915 273.122l7.194-6.946 48.626 50.353-7.194 6.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.786 349.133l-6.946-7.194 86.32-83.359 6.947 7.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.337 254.366l7.194-6.946 48.626 50.354-7.194 6.946z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaygroundLine);
export default __webpack_public_path__ + "static/media/playground-line.a3b55aae1cf63ef3209994c5acd87cfc.svg";
export { ForwardRef as ReactComponent };